import React from 'react'
import { useParams, useRouteMatch } from 'react-router-dom'
import { Loader } from '../../components'
import { NotFound404 } from '../NotFound404'
import { graphql } from '../../gql'
import { useGQLQuery } from '../../hooks/GQLUtilityHooks'
import { OrderGroupDetailContext } from './context/OrderGroupDetailContext'
import { Header } from './components/Header'
import { GroupOrders } from './components/GroupOrders'
import { GroupClearanceItems } from './GroupClearanceItems'
import { useSubmitAllOrders } from './hooks/useSubmitAllOrders'

const OrderGroupDetailQuery = graphql(`
  query OrderGroupDetail($id: Int!) {
    orderGroup(id: $id) {
      data {
        ...Header_OrderGroup
        ...GroupOrders_OrderGroup
        ...GroupClearanceItems_OrderGroup
        ...SubmitAllOrders_OrderGroup
        orders {
          id
        }
      }
      errors
    }
  }
`)

export const OrderGroupDetails: React.FC = () => {
  const params = useParams<{ groupId: string }>()
  const groupId = parseInt(params?.groupId) || 0
  const { path } = useRouteMatch()

  const { refetch, isLoading, isError, data } = useGQLQuery(OrderGroupDetailQuery, ['orderGroup'], {
    id: groupId,
  })

  const {
    submitAllOrders,
    stop,
    isStopping,
    allOrdersHasSameStatus,
    processStatus,
    currentProgress,
    isPending,
    sortOrdersByProcessStatus,
    error,
    errorsByOrderId,
  } = useSubmitAllOrders({
    orderGroup: data || null,
  })

  if (isLoading) return <Loader size="fill-container" />

  if (isError || !data) return <NotFound404 />

  return (
    <OrderGroupDetailContext.Provider value={{ orderGroup: data }}>
      <div className="h-[100vh] flex flex-col">
        <Header
          handleSubmit={submitAllOrders}
          handleStop={stop}
          isStopping={isStopping}
          allOrdersHasSameStatus={allOrdersHasSameStatus}
          processStatus={processStatus}
          isSubmitting={isPending}
        />
        <div className="flex-1 overflow-y-auto p-main">
          <div className="bg-white rounded-lg p-4 overflow-hidden">
            <GroupClearanceItems />
          </div>
          <div className="bg-white rounded-lg p-4 overflow-hidden">
            <GroupOrders
              currentProgress={currentProgress}
              sortOrders={sortOrdersByProcessStatus}
              processStatus={processStatus}
              errorsByOrderId={errorsByOrderId}
            />
          </div>

          {/* </div> */}
        </div>
      </div>
    </OrderGroupDetailContext.Provider>
  )
}
